import React from "react";
import InfoSection from "../common/InfoSection";
import { CloudHoistingData2 } from "../../constants/data";

function CloudHoisting() {
  return (
    <div className="bg-darkPurple">
      <div className="max-w-1200 mx-auto w-full">
        <div className="px-6 sm:px-[7rem] lg:px-0 py-20 sm:py-8">
          <div className="flex flex-col gap-4">
            <InfoSection
              title="SECURITY"
              subtitle="Cloud-based or On-Premise Hosting"
              description="RegTechFlow comes equipped with innovative features that make managing your corporate, compliance, and license needs easier than ever:"
              additionalText=""
              width="max-w-2xl"
              textColor="white"
              paraColor="white"
              descriptionHidden={false}
            />
            <div className="flex flex-col lg:flex-row">
              {CloudHoistingData2.map((cloud, idx) => {
                return (
                  <div
                    key={idx}
                    className="flex  lg:items-start items-center flex-col gap-4"
                  >
                    <div className="div px-12">
                      <img
                        src={cloud.img}
                        alt={cloud.head}
                        className="object-contain w-[230px] h-[207px]"
                      />
                    </div>
                    <div className="flex flex-col md:items-start md:px-12 items-start gap-2 text-white">
                      <div className="text-xl font-bold">
                        {cloud.head}
                      </div>
                      <div className="text-base sm:text-sm leading-7 font-normal md:w-[75%] w-full">
                        {cloud.title}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CloudHoisting;
